import { ds } from '@/components/lib/design.system';
import { designSystem } from '@/styles/styles';

const baseStyles = `
    body {
        width: calc(100% - 16px);
        background-color: ${designSystem.colors.neutral900};
        font-family: 'SF Pro Display', sans-serif;
        padding-bottom: 40px;
    }

    .container {
        padding-left: 8px;
        padding-right: 8px;
    }
`;

const formStyles = `
    #payment-form {
        display: flex;
        flex-direction: column;
    }

    .cardInfo {
        margin-bottom: 8px;
    }

    .cardInfo .sectionHeaderWrapper {
        margin-bottom: 14px;
    }

    .sectionHeaderWrapper {
        margin-bottom: 12px;
    }
`;

const sectionHeaderStyles = `
    .sectionHeader {
        color: ${ds.colorValue.text.primary};
        font-size: 17px;
        font-weight: 590;
        line-height: 24px;
        letter-spacing: -0.43px;
    }
`;

const errorStyles = `
    .errorMessage {
        display: none;
        margin-top: 8px;
        color: #f0423c;
        padding-left: 16px;
    }
`;

const inputStyles = `
    .inputWrapper {
        margin-bottom: 16px;
    }

    .inputContainer {
        width: 100%;
        position: relative;
        display: flex;
        flex: 1;
        outline: 0;
        height: 60px;
    }

    .label {
        color: ${designSystem.colors.neutral300};
        font-size: 15px;
        position: absolute;
        left: 16px;
        top: 50%;
        transform: translateY(-50%);
        transition: all 0.3s;
    }

    .htmlInput:focus + .htmlLabel,
    .htmlInput:valid + .htmlLabel,
    .floatingLabel {
        font-size: 13px;
        top: 10px;
        transform: translateY(0);
    }
    .htmlInput:focus {
        border-radius: 12px;
    }

    .paysafeLabel {
        z-index: -1;
    }

    .inputField {
        flex: 1;
        border: none;
        display: flex;
        outline: 0;
        font-size: 15px;
        position: relative;
        padding-left: 16px;
        padding-top: 16px;
        border: 1px solid #2f3138;
        border-radius: 12px;
        overflow: hidden;
    }

    .iframeInput {
        margin-top: 9px;
        flex: 1;
    }

    .htmlInput {
        background-color: ${designSystem.colors.neutral900};
        width: 100%;
        color: ${ds.colorValue.text.primary};
    }

    .htmlInput:focus {
        outline: none;
        border: 2px solid ${ds.colorValue.background.neutral.inverse};
    }

    .expiryDate,
    .state {
        flex: 1;
    }

    .cvv,
    .zip {
        flex: 1;
    }

`;

const depositBtnStyles = `
    .flexContainer {
        display: flex;
        column-gap: 16px;
    }

    #deposit {
        width: 100%;
        height: 48px;
        font-size: 16px;
        line-hight: 24px;
        letter-spacing: -0.31px;
        border-radius: 14px;
        font-weight: 600;
        color: ${designSystem.colors.neutral900};
        border: none;
        cursor: pointer;
        transition: all 0.3s ease;
    }

    #deposit:disabled {
        background-color: ${designSystem.colors.neutral700};
        color: ${designSystem.colors.neutral400};
        cursor: not-allowed;
    }

    .btnContainer {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        flex-direction: column;
        gap: 12px;
        padding: 16px;
        z-index: 10;
        box-sizing: border-box;
        background-color: ${designSystem.colors.neutral900};
    }
`;

const predictionDropdownStyles = `
    #predictions {
        display: block;
        position: absolute;
        top: 64px;
        left: 0;
        right: 0;
        z-index: 1;
        list-style-type: none;
        padding: 24px 16px;
        padding-bottom: 0;
        margin: 0;
        margin-top: -5px;
        background: ${designSystem.colors.neutral900};
        border: 2px solid ${ds.colorValue.border.strong};
        border-top-color: transparent;
        border-radius: 4px;
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;
        max-height: 200px;
        overflow-y: auto;
        display: none;
    }

    #predictions li {
        font-size: 15px;
        letter-spacing: -0.23px;
        color: ${ds.colorValue.text.secondary};
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        border-bottom: 0.5px solid ${ds.colorValue.border.strong};
        padding-bottom: 16px;
        margin-bottom: 16px;
        width: 100%;
    }

    #predictions li:last-child {
        border-bottom: none;
    }
`;

const billingWarningStyles = `
    .billing-warning {
        font-size: 13px;
        font-weight: 400;
        line-height: 20px;
        color: ${designSystem.colors.neutral300};
    }
`;

const loadingStyles = `
    .loading-button {
        background-color: ${designSystem.colors.neutral300};
        color: #666;
        border-color: ${designSystem.colors.neutral300};
        pointer-events: none; /* Disable interactions */
    }
`;

export const css = `
    ${baseStyles}
    ${formStyles}
    ${sectionHeaderStyles}
    ${errorStyles}
    ${inputStyles}
    ${depositBtnStyles}
    ${predictionDropdownStyles}
    ${billingWarningStyles}
    ${loadingStyles}
`;
